// extracted by mini-css-extract-plugin
export default {"notesPage":"NotesPage_notesPage__OFVBh","notesGrid":"NotesPage_notesGrid__dlATY","note":"NotesPage_note__8u0Ve"};